<template>
  <div>
    <b-container fluid class="content">
      <b-row class="mt-4">
        <b-col>
          <b-card no-body>
            <b-card-body>
              <b-row class="align-items-center border-bottom pb-3 mb-3">
                <b-col>
                  <h4 class="mb-0">H5 Store Hours & Menu</h4>
                  <div class="text-muted">Store: {{ LocationID }}</div>
                </b-col>
                <b-col class="text-right">
                  <el-button size="small" @click="go_back">{{ $t("Back") }}</el-button>
                  <el-button type="primary" size="small" @click="save_hours">{{ $t("Submit") }}</el-button>
                </b-col>
              </b-row>

              <b-alert
                :show="messageCountdown"
                dismissible
                variant="success"
                @dismissed="messageCountdown = 0"
              >
                {{ text_message }}
              </b-alert>

              <b-tabs content-class="mt-3">
                <b-tab title="Weekly Hours" active>
                  <div
                    v-for="day in weekDays"
                    :key="day.value"
                    class="day-block"
                  >
                    <b-row class="align-items-center mb-2">
                      <b-col cols="3">
                        <strong>{{ day.label }}</strong>
                        <span
                          class="ml-2 badge"
                          :class="weeklyHours[day.value].length ? 'badge-success' : 'badge-secondary'"
                        >
                          {{ weeklyHours[day.value].length ? "Open" : "Closed" }}
                        </span>
                      </b-col>
                      <b-col class="text-right">
                        <b-form-select
                          v-model="copySourceMap[day.value]"
                          :options="weekdayCopyOptions(day.value)"
                          size="sm"
                          class="d-inline-block mr-2"
                          style="width: 140px;"
                        />
                        <el-button size="mini" @click="copy_weekday_slots(day.value)">
                          Copy
                        </el-button>
                        <el-button size="mini" type="primary" @click="add_week_slot(day.value)">
                          Add Time
                        </el-button>
                      </b-col>
                    </b-row>

                    <div v-if="weeklyHours[day.value].length">
                      <b-row
                        v-for="(slot, index) in weeklyHours[day.value]"
                        :key="day.value + '-' + index"
                        class="period-row"
                      >
                        <b-col cols="3">
                          <b-form-input
                            v-model="slot.slot_name"
                            size="sm"
                            placeholder="Name"
                          />
                        </b-col>
                        <b-col cols="2">
                          <b-form-select
                            v-model="slot.open_time"
                            :options="timeOptions"
                            size="sm"
                          />
                        </b-col>
                        <b-col cols="2">
                          <b-form-select
                            v-model="slot.close_time"
                            :options="timeOptions"
                            size="sm"
                          />
                        </b-col>
                        <b-col cols="4">
                          <b-form-select
                            v-model="slot.menu_id"
                            :options="menuOptions"
                            size="sm"
                          />
                        </b-col>
                        <b-col cols="1" class="text-right">
                          <el-button
                            type="danger"
                            size="mini"
                            @click="remove_week_slot(day.value, index)"
                          >
                            Del
                          </el-button>
                        </b-col>
                      </b-row>
                    </div>
                  </div>
                </b-tab>

                <b-tab title="Date Overrides">
                  <b-row class="align-items-center mb-3">
                    <b-col>
                      <h5 class="mb-0">Date Overrides</h5>
                    </b-col>
                    <b-col class="text-right">
                      <el-button size="small" type="primary" @click="add_date_override">
                        Add Date
                      </el-button>
                    </b-col>
                  </b-row>

                  <div
                    v-for="(override, overrideIndex) in dateOverrides"
                    :key="overrideIndex"
                    class="override-block"
                  >
                    <b-row class="align-items-center mb-2">
                      <b-col cols="3">
                        <b-form-input
                          v-model="override.work_date"
                          type="date"
                          size="sm"
                        />
                      </b-col>
                      <b-col cols="3">
                        <b-form-checkbox
                          v-model="override.is_closed"
                          :value="true"
                          :unchecked-value="false"
                          switch
                          @change="date_closed_changed(override)"
                        >
                          Closed all day
                        </b-form-checkbox>
                      </b-col>
                      <b-col class="text-right">
                        <el-button
                          v-if="!override.is_closed"
                          size="mini"
                          type="primary"
                          @click="add_date_slot(override)"
                        >
                          Add Time
                        </el-button>
                        <el-button
                          size="mini"
                          type="danger"
                          @click="remove_date_override(overrideIndex)"
                        >
                          Delete Date
                        </el-button>
                      </b-col>
                    </b-row>

                    <div v-if="!override.is_closed">
                      <b-row
                        v-for="(slot, slotIndex) in override.slots"
                        :key="overrideIndex + '-' + slotIndex"
                        class="period-row"
                      >
                        <b-col cols="3">
                          <b-form-input
                            v-model="slot.slot_name"
                            size="sm"
                            placeholder="Name"
                          />
                        </b-col>
                        <b-col cols="2">
                          <b-form-select
                            v-model="slot.open_time"
                            :options="timeOptions"
                            size="sm"
                          />
                        </b-col>
                        <b-col cols="2">
                          <b-form-select
                            v-model="slot.close_time"
                            :options="timeOptions"
                            size="sm"
                          />
                        </b-col>
                        <b-col cols="4">
                          <b-form-select
                            v-model="slot.menu_id"
                            :options="menuOptions"
                            size="sm"
                          />
                        </b-col>
                        <b-col cols="1" class="text-right">
                          <el-button
                            type="danger"
                            size="mini"
                            @click="remove_date_slot(override, slotIndex)"
                          >
                            Del
                          </el-button>
                        </b-col>
                      </b-row>
                    </div>
                  </div>

                  <div v-if="dateOverrides.length == 0" class="empty-state">
                    No date overrides
                  </div>
                </b-tab>
              </b-tabs>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
    <div class="loading-overlay" v-if="show_loading">
      <div class="spinner"></div>
      <p>Loading...</p>
    </div>
  </div>
</template>

<script>
import { Button } from "element-ui";
import { getStore } from "../../util/helper";

const axios = require("axios");

export default {
  components: {
    [Button.name]: Button,
  },
  data() {
    return {
      show_loading: false,
      token: "",
      user_id: 0,
      LocationID: "",
      menuList: [],
      weeklyHours: {},
      dateOverrides: [],
      text_message: "",
      messageCountdown: 0,
      weekDays: [
        { value: 1, label: "Monday" },
        { value: 2, label: "Tuesday" },
        { value: 3, label: "Wednesday" },
        { value: 4, label: "Thursday" },
        { value: 5, label: "Friday" },
        { value: 6, label: "Saturday" },
        { value: 0, label: "Sunday" },
      ],
      timeOptions: [],
      copySourceMap: {},
    };
  },
  computed: {
    menuOptions() {
      let options = [{ value: 0, text: "Select Menu" }];
      for (let i = 0; i < this.menuList.length; i++) {
        options.push({
          value: parseInt(this.menuList[i].IDn),
          text: this.menuList[i].Name1,
        });
      }
      return options;
    },
  },
  methods: {
    empty_weekly_hours() {
      return {
        0: [],
        1: [],
        2: [],
        3: [],
        4: [],
        5: [],
        6: [],
      };
    },
    build_time_options() {
      let options = [];
      for (let minutes = 0; minutes <= 1440; minutes += 15) {
        let hour = Math.floor(minutes / 60);
        let minute = minutes % 60;
        let value = this.pad2(hour) + ":" + this.pad2(minute);
        options.push({ value: value, text: value });
      }
      return options;
    },
    pad2(value) {
      return String(value).padStart(2, "0");
    },
    new_slot(name) {
      return {
        slot_name: name,
        open_time: "09:00",
        close_time: "17:00",
        menu_id: this.menuList.length ? parseInt(this.menuList[0].IDn) : 0,
      };
    },
    today_string() {
      let now = new Date();
      return now.getFullYear() + "-" + this.pad2(now.getMonth() + 1) + "-" + this.pad2(now.getDate());
    },
    normalize_time(value) {
      if (!value) return "";
      let text = String(value);
      if (text.length >= 5) {
        return text.substring(0, 5);
      }
      return text;
    },
    time_to_minutes(value) {
      if (!value) return false;
      let text = this.normalize_time(value);
      if (text == "24:00") return 1440;
      let match = text.match(/^([01][0-9]|2[0-3]):([0-5][0-9])$/);
      if (!match) return false;
      return parseInt(match[1]) * 60 + parseInt(match[2]);
    },
    minutes_to_time(minutes) {
      minutes = Math.max(0, Math.min(1440, minutes));
      let hour = Math.floor(minutes / 60);
      let minute = minutes % 60;
      return this.pad2(hour) + ":" + this.pad2(minute);
    },
    hydrate_hours(rows) {
      this.weeklyHours = this.empty_weekly_hours();
      this.dateOverrides = [];
      if (!rows) return;

      for (let i = 0; i < rows.length; i++) {
        let row = rows[i];
        if (row.day_type == "weekday") {
          let weekday = parseInt(row.weekday);
          if (!this.weeklyHours.hasOwnProperty(weekday) || row.is_closed) {
            continue;
          }
          this.weeklyHours[weekday].push({
            slot_name: row.slot_name || "",
            open_time: this.normalize_time(row.open_time),
            close_time: this.normalize_time(row.close_time),
            menu_id: parseInt(row.menu_id || 0),
          });
        } else if (row.day_type == "date") {
          let workDate = row.work_date || "";
          if (!workDate) continue;
          let override = this.find_date_override(workDate);
          if (!override) {
            override = {
              work_date: workDate,
              is_closed: false,
              slots: [],
            };
            this.dateOverrides.push(override);
          }
          if (row.is_closed) {
            override.is_closed = true;
            override.slots = [];
          } else if (!override.is_closed) {
            override.slots.push({
              slot_name: row.slot_name || "",
              open_time: this.normalize_time(row.open_time),
              close_time: this.normalize_time(row.close_time),
              menu_id: parseInt(row.menu_id || 0),
            });
          }
        }
      }
      this.sort_all_slots();
    },
    sort_all_slots() {
      for (let day in this.weeklyHours) {
        this.weeklyHours[day].sort((a, b) => this.compare_slots(a, b));
      }
      this.dateOverrides.sort(function(a, b) {
        return a.work_date > b.work_date ? 1 : -1;
      });
      for (let i = 0; i < this.dateOverrides.length; i++) {
        this.dateOverrides[i].slots.sort((a, b) => this.compare_slots(a, b));
      }
    },
    compare_slots(a, b) {
      return this.time_to_minutes(a.open_time) - this.time_to_minutes(b.open_time);
    },
    get_weekday_label(weekday) {
      let day = this.weekDays.find(function(item) {
        return parseInt(item.value) === parseInt(weekday);
      });
      return day ? day.label : "Day";
    },
    weekdayCopyOptions(currentWeekday) {
      let options = [{ value: "", text: "Copy from..." }];
      for (let i = 0; i < this.weekDays.length; i++) {
        let day = this.weekDays[i];
        if (parseInt(day.value) === parseInt(currentWeekday)) continue;
        options.push({ value: day.value, text: day.label });
      }
      return options;
    },
    copy_weekday_slots(targetWeekday) {
      let sourceWeekday = this.copySourceMap[targetWeekday];
      if (sourceWeekday === undefined || sourceWeekday === "" || parseInt(sourceWeekday) === parseInt(targetWeekday)) {
        alert("Please select a different day to copy from.");
        return;
      }
      this.weeklyHours[targetWeekday] = JSON.parse(JSON.stringify(this.weeklyHours[sourceWeekday]));
      this.sort_all_slots();
    },
    can_add_slot(slots, candidate) {
      let start = this.time_to_minutes(candidate.open_time);
      let end = this.time_to_minutes(candidate.close_time);
      if (start === false || end === false || end <= start) {
        return false;
      }
      for (let i = 0; i < slots.length; i++) {
        let slot = slots[i];
        let existingStart = this.time_to_minutes(slot.open_time);
        let existingEnd = this.time_to_minutes(slot.close_time);
        if (existingStart === false || existingEnd === false || existingEnd <= existingStart) {
          continue;
        }
        if (start < existingEnd && end > existingStart) {
          return false;
        }
      }
      return true;
    },
    next_available_slot(slots, name) {
      let candidate = this.new_slot(name);
      if (this.can_add_slot(slots, candidate)) {
        return candidate;
      }

      let ranges = [];
      for (let i = 0; i < slots.length; i++) {
        let start = this.time_to_minutes(slots[i].open_time);
        let end = this.time_to_minutes(slots[i].close_time);
        if (start === false || end === false || end <= start) {
          continue;
        }
        ranges.push({ start: start, end: end });
      }
      ranges.sort(function(a, b) {
        return a.start - b.start;
      });

      let durations = [60, 15];
      for (let d = 0; d < durations.length; d++) {
        let duration = durations[d];
        if (ranges.length > 0) {
          let afterLast = ranges[ranges.length - 1].end;
          if (afterLast + duration <= 1440) {
            candidate.open_time = this.minutes_to_time(afterLast);
            candidate.close_time = this.minutes_to_time(afterLast + duration);
            if (this.can_add_slot(slots, candidate)) {
              return candidate;
            }
          }
        }

        let cursor = 0;
        for (let j = 0; j < ranges.length; j++) {
          if (cursor + duration <= ranges[j].start) {
            candidate.open_time = this.minutes_to_time(cursor);
            candidate.close_time = this.minutes_to_time(cursor + duration);
            if (this.can_add_slot(slots, candidate)) {
              return candidate;
            }
          }
          cursor = Math.max(cursor, ranges[j].end);
        }
      }

      return null;
    },
    find_date_override(workDate) {
      for (let i = 0; i < this.dateOverrides.length; i++) {
        if (this.dateOverrides[i].work_date == workDate) {
          return this.dateOverrides[i];
        }
      }
      return null;
    },
    add_week_slot(weekday) {
      let candidate = this.next_available_slot(this.weeklyHours[weekday], "Period " + (this.weeklyHours[weekday].length + 1));
      if (!candidate) {
        alert(this.get_weekday_label(weekday) + ": no available time period remains.");
        return;
      }
      this.weeklyHours[weekday].push(candidate);
    },
    remove_week_slot(weekday, index) {
      this.weeklyHours[weekday].splice(index, 1);
    },
    add_date_override() {
      let today = this.today_string();
      this.dateOverrides.push({
        work_date: today,
        is_closed: true,
        slots: [],
      });
    },
    remove_date_override(index) {
      this.dateOverrides.splice(index, 1);
    },
    date_closed_changed(override) {
      if (override.is_closed) {
        override.slots = [];
      } else if (override.slots.length == 0) {
        override.slots.push(this.new_slot("Period 1"));
      }
    },
    add_date_slot(override) {
      let candidate = this.next_available_slot(override.slots, "Period " + (override.slots.length + 1));
      if (!candidate) {
        let label = override.work_date || "Date override";
        alert(label + ": no available time period remains.");
        return;
      }
      override.is_closed = false;
      override.slots.push(candidate);
    },
    remove_date_slot(override, index) {
      override.slots.splice(index, 1);
    },
    validate_slots(slots, label) {
      let ranges = [];
      for (let i = 0; i < slots.length; i++) {
        let slot = slots[i];
        if (!slot.slot_name || !slot.slot_name.trim()) {
          return label + ": name is required.";
        }
        let start = this.time_to_minutes(slot.open_time);
        let end = this.time_to_minutes(slot.close_time);
        if (start === false || end === false) {
          return label + ": time is invalid.";
        }
        if (end <= start) {
          return label + ": end time must be after start time.";
        }
        if (!parseInt(slot.menu_id)) {
          return label + ": menu is required.";
        }
        ranges.push({ start: start, end: end });
      }
      ranges.sort(function(a, b) {
        return a.start - b.start;
      });
      for (let j = 1; j < ranges.length; j++) {
        if (ranges[j].start < ranges[j - 1].end) {
          return label + ": time periods cannot overlap.";
        }
      }
      return "";
    },
    validate_hours() {
      for (let i = 0; i < this.weekDays.length; i++) {
        let day = this.weekDays[i];
        let err = this.validate_slots(this.weeklyHours[day.value], day.label);
        if (err) return err;
      }

      let dates = {};
      for (let j = 0; j < this.dateOverrides.length; j++) {
        let override = this.dateOverrides[j];
        if (!override.work_date) {
          return "Date override requires a date.";
        }
        if (dates[override.work_date]) {
          return "Date override cannot use the same date twice.";
        }
        dates[override.work_date] = true;
        if (!override.is_closed) {
          if (override.slots.length == 0) {
            return override.work_date + ": time period is required.";
          }
          let err = this.validate_slots(override.slots, override.work_date);
          if (err) return err;
        }
      }
      return "";
    },
    build_payload() {
      let rows = [];
      for (let i = 0; i < this.weekDays.length; i++) {
        let weekday = this.weekDays[i].value;
        let slots = this.weeklyHours[weekday];
        for (let j = 0; j < slots.length; j++) {
          rows.push({
            day_type: "weekday",
            weekday: weekday,
            work_date: "",
            slot_name: slots[j].slot_name,
            open_time: slots[j].open_time,
            close_time: slots[j].close_time,
            is_closed: 0,
            menu_id: parseInt(slots[j].menu_id),
            sort_order: j + 1,
          });
        }
      }
      for (let k = 0; k < this.dateOverrides.length; k++) {
        let override = this.dateOverrides[k];
        if (override.is_closed) {
          rows.push({
            day_type: "date",
            weekday: 0,
            work_date: override.work_date,
            slot_name: "Closed",
            open_time: "",
            close_time: "",
            is_closed: 1,
            menu_id: 0,
            sort_order: 1,
          });
        } else {
          for (let p = 0; p < override.slots.length; p++) {
            rows.push({
              day_type: "date",
              weekday: 0,
              work_date: override.work_date,
              slot_name: override.slots[p].slot_name,
              open_time: override.slots[p].open_time,
              close_time: override.slots[p].close_time,
              is_closed: 0,
              menu_id: parseInt(override.slots[p].menu_id),
              sort_order: p + 1,
            });
          }
        }
      }
      return rows;
    },
    go_back() {
      this.$router.push({ path: "/onlinestore", query: { LocationID: this.LocationID } });
    },
    load_hours() {
      this.show_loading = true;
      let bodyFormData = new FormData();
      bodyFormData.append("token", this.token);
      bodyFormData.append("user_id", this.user_id);
      bodyFormData.append("LocationID", this.LocationID);
      let that = this;

      axios({
        method: "post",
        url: "/Api/Web/Store/getH5StoreHours",
        data: bodyFormData,
      })
        .then(function(response) {
          if (response.status == "200") {
            let rt = response.data;
            if (rt.status == 0) {
              that.menuList = rt.data.menuList || [];
              that.hydrate_hours(rt.data.hours || []);
            } else if (rt.status == 4) {
              alert(that.$t("No Permission"));
              that.$router.go(-1);
            } else if (rt.message != undefined) {
              alert(rt.message);
            }
          }
        })
        .catch(function() {
          that.$router.push("/login");
        })
        .finally(function() {
          that.show_loading = false;
        });
    },
    save_hours(event) {
      if (event) {
        event.preventDefault();
      }
      let err = this.validate_hours();
      if (err) {
        alert(err);
        return;
      }
      this.sort_all_slots();
      this.show_loading = true;
      let bodyFormData = new FormData();
      bodyFormData.append("token", this.token);
      bodyFormData.append("user_id", this.user_id);
      bodyFormData.append("LocationID", this.LocationID);
      bodyFormData.append("hours", JSON.stringify(this.build_payload()));
      let that = this;

      axios({
        method: "post",
        url: "/Api/Web/Store/updateH5StoreHours",
        data: bodyFormData,
      })
        .then(function(response) {
          if (response.status == "200") {
            let rt = response.data;
            if (rt.status == 0) {
              that.hydrate_hours(rt.data.hours || []);
              that.text_message = that.$t("Data Updated Successfully");
              that.messageCountdown = 3;
            } else if (rt.status == 4) {
              alert(that.$t("No Permission"));
              that.$router.go(-1);
            } else if (rt.message != undefined) {
              alert(rt.message);
            }
          }
        })
        .catch(function() {
          that.$router.push("/login");
        })
        .finally(function() {
          that.show_loading = false;
        });
    },
    init_data() {
      this.token = getStore("token");
      this.user_id = getStore("user_id");
      if (!this.token || !this.user_id) {
        this.$router.push("/login");
        return;
      }
      this.LocationID = this.$route.query.LocationID;
      if (!this.LocationID) {
        this.$router.push("/store");
        return;
      }
      this.load_hours();
    },
  },
  mounted() {
    let name = getStore("username");
    if (name && name != undefined && ((name == "PKAdmin") || (name == "posking"))) {
      this.weeklyHours = this.empty_weekly_hours();
      this.timeOptions = this.build_time_options();
      this.init_data();
    } else {
      this.$router.push("/store");
    }
  },
};
</script>

<style scoped>
.content {
  padding-top: 80px;
}
.day-block,
.override-block {
  border: 1px solid #e9ecef;
  border-radius: 4px;
  margin-bottom: 12px;
  padding: 12px;
}
.period-row {
  align-items: center;
  margin-bottom: 8px;
}
.empty-state {
  border: 1px dashed #ced4da;
  border-radius: 4px;
  color: #6c757d;
  padding: 20px;
  text-align: center;
}
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
.spinner {
  border: 8px solid rgba(0, 0, 0, 0.1);
  border-top: 8px solid #3498db;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
